import React from 'react';

// API/Components
import {
	isEmpty,
	validValue,
	isValidValue,
	measUnitsConversion,
	userMetricUnits
} from './enums';

// Material UI
import Backdrop from '@mui/material/Backdrop';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

// Determine if the user is using metric or imperial units
const tempMeasurementUnits = userMetricUnits() ? '°C' : '°F';

// Blank value placeholders
const blankVoltage = '--.---';
const blankImpedance = '-.---';
// const blankImpedanceIncrease = '--.-';
const blankTemperature = '--.-';

// Border Coloring
const borderStyle = '1px solid #D8D7D6';

export default function UnitStatsSummary({ unitAnalysisData, loading = false }) {

	let tableData = [
		{ name: 'Maximum', voltage: blankVoltage, impedance: blankImpedance, temperature: blankTemperature },
		{ name: 'Average', voltage: blankVoltage, impedance: blankImpedance, temperature: blankTemperature },
		{ name: 'Minimum', voltage: blankVoltage, impedance: blankImpedance, temperature: blankTemperature },
	];

	if (unitAnalysisData !== undefined && !isEmpty(unitAnalysisData)) {

		const statsData = unitAnalysisData.stats;
		tableData = [
			{
				name: 'Maximum',
				voltage: validValue(statsData.voltage.max, blankVoltage),
				impedance: validValue(statsData.impedance.max, blankImpedance),
				// imped_increase: validValue(statsData.impedance.increase, blankImpedanceIncrease),
				temperature: isValidValue(statsData.temperature.max) ? measUnitsConversion(statsData.temperature.max).toFixed(1) : blankTemperature,
			},
			{
				name: 'Average',
				voltage: validValue(statsData.voltage.avg, blankVoltage),
				impedance: validValue(statsData.impedance.avg, blankImpedance),
				// imped_increase: validValue(statsData.impedance.increase_avg, blankImpedanceIncrease),
				temperature: isValidValue(statsData.temperature.avg) ? measUnitsConversion(statsData.temperature.avg).toFixed(1) : blankTemperature,
			},
			{
				name: 'Minimum',
				voltage: validValue(statsData.voltage.min, blankVoltage),
				impedance: validValue(statsData.impedance.min, blankImpedance),
				// imped_increase: validValue(statsData.impedance.increase_min, blankImpedanceIncrease),
				temperature: isValidValue(statsData.temperature.min) ? measUnitsConversion(statsData.temperature.min).toFixed(1) : blankTemperature,
			},
		];
	}

	return (
		<Card style={{ border: borderStyle, borderRadius: '5px', boxShadow: '2px 2px 4px gray', px: 0 }}>
			<Box sx={{ backgroundColor: 'lightgray', p: 1 }}>
				<Typography sx={{ textAlign: 'center', fontFamily: 'Saira,sans-serif', fontWeight: 'bold' }}>
					Unit Stats Summary
				</Typography>
			</Box>
			<CardContent style={{ padding: 0, position: 'relative' }}>
				{loading && (
					<Backdrop
						sx={{
							color: '#fff',
							zIndex: (theme) => theme.zIndex.drawer + 1,
							position: 'absolute',
							top: 0,
							left: 0,
							width: '100%',
							height: '100%',
							borderRadius: 'inherit',
							backgroundColor: 'rgba(0,0,0,0.5)'
						}}
						open={true}
					>
						<CircularProgress color="inherit" />
					</Backdrop>
				)}
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell sx={{ border: borderStyle, p: 0 }}></TableCell>
								<TableCell sx={{ border: borderStyle, p: 0 }}>
									<Typography sx={{ fontFamily: 'Saira,sans-serif', fontWeight: 'bold', textAlign: 'center', fontSize: '14px' }} >
										Voltage
									</Typography>
								</TableCell>
								<TableCell sx={{ border: borderStyle, p: 0 }}>
									<Typography sx={{ fontFamily: 'Saira,sans-serif', fontWeight: 'bold', textAlign: 'center', fontSize: '14px' }} >
										Impedance
									</Typography>
								</TableCell>
								{/* <TableCell sx={{ border: '1px solid #D8D7D6', p: 0 }}>
									<Typography sx={{ fontFamily: 'Saira,sans-serif', fontWeight: 'bold', textAlign: 'center', fontSize: '14px' }} >
										Imped Increase
									</Typography>
								</TableCell> */}
								<TableCell sx={{ border: borderStyle, p: 0 }}>
									<Typography sx={{ fontFamily: 'Saira,sans-serif', fontWeight: 'bold', textAlign: 'center', fontSize: '14px' }} >
										Temperature
									</Typography>
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{tableData.map((row, index) => (
								<TableRow key={index} sx={{ backgroundColor: (index % 2 === 0) ? 'rgba(0, 0, 0, 0.05)' : 'inherit' }}>
									<TableCell sx={{ borderRight: borderStyle, p: 0, }}>
										<Typography sx={{ fontFamily: 'Saira,sans-serif', fontWeight: 'bold', fontSize: '14px' }}>{row.name}</Typography>
									</TableCell>
									<TableCell sx={{ borderRight: borderStyle, p: 0, }}>{row.voltage} V</TableCell>
									<TableCell sx={{ borderRight: borderStyle, p: 0, }}>{row.impedance} mΩ</TableCell>
									{/* <TableCell sx={{ borderRight: borderStyle, p: 0, }}>{row.imped_increase} %</TableCell> */}
									<TableCell sx={{ p: 0, }}>{row.temperature}{tempMeasurementUnits}</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			</CardContent>
		</Card>
	);
}